"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const date_helper_1 = require("../../helpers/date.helper");
const scoring_settings_serializer_1 = require("./scoring-settings.serializer");
class AssignmentSerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(scoringSettingsSerializer = new scoring_settings_serializer_1.ScoringSettingsSerializer()) {
        super();
        this.scoringSettingsSerializer = scoringSettingsSerializer;
    }
    serializeOne(data) {
        return {
            id: data.id,
            districtId: data.districtId,
            schoolId: data.schoolId,
            enrollmentPeriodId: data.enrollmentPeriodId,
            ownerId: data.ownerId,
            contextId: data.contextId,
            title: data.title,
            instructions: data.instructions,
            startedAt: (0, date_helper_1.toLocalDate)(data.startedAt),
            completedAt: (0, date_helper_1.toLocalDate)(data.completedAt),
            status: data.status,
            assignedAt: (0, date_helper_1.toLocalDate)(data.assignedAt),
            bundleId: data.bundleId,
            curriculumId: data.curriculumId,
            totalAssigned: data.totalAssigned ? data.totalAssigned : 0,
            totalSubmitted: data.totalSubmitted ? data.totalSubmitted : 0,
            totalInProgress: data.totalInProgress ? data.totalInProgress : 0,
            totalNotStarted: data.totalNotStarted ? data.totalNotStarted : 0,
            resourceIds: data.resourceIds ? data.resourceIds : undefined,
            resourceParentIds: data.resourceParentIds,
            evidenceType: data.evidenceType ? data.evidenceType : undefined,
            autoLaunch: data.autoLaunch ? data.autoLaunch : undefined,
            startDate: (0, date_helper_1.toLocalDate)(data.startDate),
            dueDate: (0, date_helper_1.toLocalDate)(data.dueDate),
            closedAt: data.closedAt ? data.closedAt : undefined,
            closedBy: data.closedBy ? data.closedBy : undefined,
            scoringSettings: data.scoringSettings
                ? this.scoringSettingsSerializer.serializeOne(data.scoringSettings)
                : null,
            assignmentResources: data.assignmentResources
                ? this.serializeResources(data.assignmentResources)
                : [],
            stoppedAt: data.stoppedAt,
            reopenedAt: data.reopenedAt,
            reopenedBy: data.reopenedBy,
        };
    }
    serializeStatusTotals(data) {
        return {
            totalAssigned: data.totalAssigned,
            totalOpen: data.totalOpen,
            totalReview: data.totalReview,
            totalDone: data.totalDone,
        };
    }
    serializeResources(data) {
        return data.map((assignmentResource) => ({
            resourceId: assignmentResource.resourceId,
            parentId: assignmentResource.parentId,
            parentType: assignmentResource.parentType,
            scoringSettings: assignmentResource.scoringSettings
                ? this.scoringSettingsSerializer.serializeOne(assignmentResource.scoringSettings)
                : null,
            teacherGuidance: assignmentResource.teacherGuidance || [],
        }));
    }
    serializeStudents(data) {
        return data.map((student) => ({
            id: student.id,
            status: student.status,
        }));
    }
}
exports.AssignmentSerializer = AssignmentSerializer;
//# sourceMappingURL=assignment.serializer.js.map